import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faSpinnerThird} from "@fortawesome/pro-solid-svg-icons";
import {faCircle} from "@fortawesome/pro-light-svg-icons";
import {LoaderType} from "./LoaderTypes";
import StackHorizontal from "../Wrappers/StackHorizontal";
import StackVertical from "../Wrappers/StackVertical";
import {FlexAlign, FlexGap, FlexJustify} from "../../Data/Enums/LayoutEnums";

const GenericLoader = (props: LoaderType) => {
    const LoaderContent = () => {
        return (
            <>
                <div className={'loader-spinners'}>
                    <FontAwesomeIcon icon={faCircle} size={'3x'} />
                    <FontAwesomeIcon icon={faSpinnerThird} size={'3x'} spin={true} />
                </div>
                <div>{props.label ? `${props.label} Loading...` : 'Loading...'}</div>
            </>
        )
    }

    if (props.inline) {
        return (
            <StackHorizontal gap={FlexGap.Medium} align={FlexAlign.Center}>
                <LoaderContent />
            </StackHorizontal>
        )
    }

    return (
        <StackVertical fillHeight={true} gap={FlexGap.Small} align={FlexAlign.Center} justify={FlexJustify.Center}>
            <LoaderContent />
        </StackVertical>
    )
}

export default GenericLoader